package com.merkost.handpass.admin.util

import kotlin.math.abs

fun formatPriceCents(cents: Long): String {
    val negative = cents < 0
    val absCents = abs(cents)
    val dollars = absCents / 100
    val remainder = (absCents % 100).toInt()
    val body = if (remainder == 0) "$$dollars" else "$$dollars.${remainder.toString().padStart(2, '0')}"
    return if (negative) "-$body" else body
}
